import styled from "styled-components";
import { Card, Button } from "antd";

export const XButton = styled(Button)`
  position: absolute;
  top: "6px";
  right: "20px";
`;

export const SlotView = styled(Card)`
  border-radius: 10px;
  justify-content: space-between;
  .ant-card-body {
    padding: 8px 8px 8px 8px;
    width: 204px;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
`;
export const SlotViewDelete = styled.div`
  cursor: pointer;
  position: relative;
  top: -3px;
  right: -7px;
  font-size: 14px;
  color: #eb2f96;
`;
export const SlotViewAdd = styled.div`
  cursor: pointer;
  position: absolute;
  bottom: 60px;
  right: 15px;
  font-size: 14px;
`;
